// export const BASE_URL = "http://educationapi.equanimitylabs.ai/";
// export const BASE_URL = "http://localhost:5000/";
export const BASE_URL =
    process.env.REACT_APP_BASE_URI || "https://backend-education.onrender.com/";